import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { isMobileApp } from 'webui/utils/version';
import { noop } from 'ts-essentials';
import { preventDefault, useBox } from 'shared/hooks/utils';
import { Box, Button, Typography } from '@mui/material';
import { FolderOpenRounded, FolderRounded, MoreHorizRounded } from '@mui/icons-material';
import { countDevicesInGroup } from 'console/sortableDeviceTree/utils/group-utils';
import * as S from './styles';
export const RenderZontNextGroupItem = memo(function RenderGroupItem(props) {
    const { node, path, onClick, openMenu, setNode, can_manage_devices, can_manage_groups, setPath, } = props;
    const _node = useBox(node);
    const _path = useBox(path);
    const openNodeMenu = useCallback((event) => {
        preventDefault(event);
        openMenu(event);
        setNode(_node.current);
        setPath(_path.current);
    }, []);
    const onOpenContextMenu = useMemo(() => isMobileApp()
        ? noop
        : (event) => {
            preventDefault(event);
            if (can_manage_devices || can_manage_groups) {
                openNodeMenu(event);
            }
        }, [can_manage_groups, can_manage_devices]);
    const group_color = useCallback(({ palette }) => palette.mode === 'dark' ? 'neutral_dark.light' : 'neutral_dark.main', []);
    return (_jsxs(S.Group, { display: "grid", height: "100%", gridTemplateColumns: "0.5fr 3fr 0.5fr", columnGap: 0.5, width: "100%", alignItems: "center", onClick: onClick, onContextMenu: onOpenContextMenu, className: 'tab-click', tabIndex: -1, children: [_jsx(Box, { ml: 1, sx: { color: group_color }, children: 'expanded' in node && node.expanded ? (_jsx(FolderOpenRounded, {})) : (_jsx(FolderRounded, {})) }), _jsx(Box, { display: "flex", alignItems: "center", columnGap: 0.5, overflow: "hidden", textOverflow: "ellipsis", children: _jsxs(Typography, { fontSize: "1.15rem", variant: "subtitle1", color: "textPrimary", noWrap: true, children: [node.title, " (", countDevicesInGroup([node]), ")"] }) }), (can_manage_devices || can_manage_groups) && (_jsx(Box, { sx: { color: group_color }, children: _jsx(Button, { color: "inherit", onClick: openNodeMenu, sx: {
                        justifySelf: 'flex-end',
                    }, className: "menuButton", title: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441 \u0433\u0440\u0443\u043F\u043F\u043E\u0439", children: _jsx(MoreHorizRounded, {}) }) }))] }));
});
